import React from 'react';
import { Modal, Text, Button } from '@shopify/polaris';
import axios from 'axios';

function DeleteArticleModal({ open, onClose, article, shopOrigin, onDeleteSuccess }) {
  const handleDelete = async () => {
    try {
      const articleId = article?.article_id;
      if (!articleId) {
        console.error('No article ID provided');
        return;
      }
      console.log("Article Data for delettion:: ", article);

      const response = await axios.post(
        `/api/delete-article/?shop=${shopOrigin}`,
        {
          articleId: `gid://shopify/Article/${articleId}`,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data.status === 'success') {
        onDeleteSuccess(articleId);
        onClose();
      } else {
        console.error('Failed to delete article:', response.data.message);
      }
    } catch (error) {
      console.error('Error deleting article:', error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Delete Article"
      primaryAction={{
        content: 'Delete',
        onAction: handleDelete,
        destructive: true,
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
    >
      <Modal.Section>
        <Text as="p">
          Are you sure you want to delete the article{' '}
          <strong>{article?.article_title}</strong>? This action cannot be undone.
        </Text>
      </Modal.Section>
    </Modal>
  );
}

export default DeleteArticleModal;